/**
 * Converts a hexadecimal color code to an RGBA color string.
 *
 * @param hex - The hexadecimal color code (e.g., "#FF5733")
 * @param alpha - The alpha (opacity) value, ranging from 0 (transparent) to 1 (opaque)
 * @returns An RGBA color string in the format "rgba(r, g, b, alpha)"
 *
 * @example
 * ```ts
 * hexToRgba("#FF5733", 0.5); // Returns "rgba(255, 87, 51, 0.5)"
 * ```
 */
export const hexToRgba = (hex: string, alpha: number) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};
